import React from 'react';
import {ProgressBarStep} from './ProgressBarStep';
import {ProgressBarStepModel} from './model';
import {MAX_VISIBLE_STEPS_COUNT} from './constants';
import './ProgressBar.scss';

export interface ProgressBarProps {
  steps: ProgressBarStepModel[];
  onClickOnStep?: (stepId: string) => void;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ steps, onClickOnStep }) => {
  const visibleSteps = steps.length > MAX_VISIBLE_STEPS_COUNT ? steps.filter((step) => Boolean(step?.selected)) : steps;

  return (
    <div className="progress-bar">
      {visibleSteps.map((step) => (
        <ProgressBarStep key={step.id} {...step} onClick={onClickOnStep ? () => onClickOnStep(step.id) : undefined} />
      ))}
    </div>
  );
};
